<script>
  import { onMount } from "svelte";
  import { SPRITES } from "../../constants/sprites";
  import { getTextsPlayerboards } from "../../constants/allTexts";
  import ComponentTiled from "./ComponentTiled.svelte";
  import {SetupStore} from "../stores/gameStore";

  export let offset,
    offsetBack,
    disabled,
    selected,
    color,
    flipped,
    onflip,
    onclick,
    board;

  const width = 500;

  let id_front = Math.round(Math.random() * 100000);
  $: if (board) {
    onMount(() => {
      window.GAME.addTooltipHtml(
        id_front.toString(),
        `<div style="display:flex; flex-direction:column; max-width: 450px; word-wrap: break-word;">
          <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
            <div class="headline">
              ${textsPlayerboards[board.front].name}
            </div>
          </div>
          <hr style="width:100%;"/>
            ${textsPlayerboards[board.front].description}
        </div>`
      );
    });
  }
  let id_back = Math.round(Math.random() * 100000);
  $: if (board) {
    onMount(() => {
      window.GAME.addTooltipHtml(
        id_back.toString(),
        `<div style="display:flex; flex-direction:column; max-width: 450px; word-wrap: break-word;">
          <div style="width:100%;display:flex;justify-content:space-between;align-items:center; gap:2rem;">
            <div class="headline">
              ${textsPlayerboards[board.back].name}
            </div>
          </div>
          <hr style="width:100%;"/>
            ${textsPlayerboards[board.back].description}
        </div>`
      );
    });
  }

  const textFlip = _('Flip');
  const textsPlayerboards = getTextsPlayerboards();
</script>

<div style:position="relative">
  {#if disabled && color}
    <div class="overlay" style:background={color}></div>
  {/if}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class:disabled
    class:selected
    class:selectable={!disabled && !selected}
    style:position="relative"
    style:outline-color={color}
  >
    {#if selected}
      <!-- <button on:click={onflip}>{textFlip}</button> -->

      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- <div
        class="btn check"
        style="position: absolute; padding: 0.5rem 1rem; bottom: 1rem; right: 1.5rem; z-index: 10; background: white; text-align: center"
        on:click={onflip}
      >
        {textFlip}
      </div> -->

      <div
        style="
          position: absolute;
          width: 8rem;
          bottom: 0.1rem;
          right: -0.3rem;
          z-index: 10;
          display: flex;
          justify-content: center;
        "
      >
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="btn check"
          style="
            padding: 0.25rem 0.5rem;
            background: white;
            text-align: center;
            font-size: 2.2rem;
          "
          on:click={onflip}
        >
          {textFlip}
        </div>
      </div>
    {/if}
    
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="wrapper"
      style:transform={!flipped ? "rotateY(0)" : ""}
      style:width
      on:click={() => {
        if (disabled) return;
        onclick();
      }}
    >
      <ComponentTiled
        {width}
        sprite={SPRITES["PLAYERBOARD"]}
        offset={[offset[1], offset[0]]}
        className="selectablePlayerBoardPlaceholder"
      />
      <div class="back">
        <ComponentTiled
          {width}
          sprite={SPRITES["PLAYERBOARD"]}
          offset={offsetBack}
          id = {id_back}
        />
        <div class="textbox">
          <div class="charactername">{textsPlayerboards[board.back].name}</div>
        </div>
      </div>
      <div class="front">
        <ComponentTiled
          {width}
          sprite={SPRITES["PLAYERBOARD"]}
          {offset}
          id = {id_front}
        />
        <div class="textbox">
          <div class="charactername">{textsPlayerboards[board.front].name}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .wrapper {
    position: relative;
    border-radius: 2px;
    box-shadow:
      0px 2px 8px 0px rgba(0, 0, 0, 0.6),
      inset 2px 2px 0px 0px rgba(255, 255, 255, 0.1),
      inset -2px -2px 0px 0px rgba(0, 0, 0, 0.1);
    transform: rotateY(180deg);
    transition: transform 0.4s;
    transform-style: preserve-3d;
    user-select: none;
  }

  .textbox {
    position: absolute;
    width: 120px;
    height: 40px;
    top: 1%;
    left: 75.7%;
  }
  .charactername {
    display: flex;
    justify-content: center;
    font-size: 41px;
    font-family: "Bigelow Rules", serif;
    font-weight: bold;
    font-variant: small-caps;
    margin: -0.5rem 0;
    transform: scale(1, 0.6);
    color: rgb(0, 0, 0);
  }

  .selectable {
    cursor: pointer;
    filter: brightness(0.8);
  }

  .selectable:hover {
    filter: brightness(1.2);
  }

  .disabled {
    filter: contrast(0.6) saturate(0.1);
    cursor: not-allowed;
  }

  .selected {
    filter: brightness(1.2);
    outline: 5px solid red;
  }

  .back {
    transform: rotateY(180deg);
  }

  .front,
  .back {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    backface-visibility: hidden;
    transform-style: preserve-3d;
  }

  :global(.selectablePlayerBoardPlaceholder) {
    opacity: 0;
    pointer-events: none;
  }

  button {
    position: absolute;
    padding: 0.5rem;
    bottom: 1rem;
    right: 1.5rem;
    width: 4rem;
    font-weight: bold;
    border-radius: 4px;
    z-index: 99;
    border: 1px solid #444;
    cursor: pointer;
  }

  .position {
    position: absolute;
    padding: 0.5rem;
    bottom: 1rem;
    right: 1.5rem;
    width: 4rem;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    mix-blend-mode: overlay;
  }
</style>
